import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/OrderRecommendations`;

export const createOrderRecommendation = async orderRecommendation => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(orderRecommendation),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateOrderRecommendation = async orderRecommendation => {
  const url = `${baseRoute}/${orderRecommendation.orderRecommendationId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(orderRecommendation),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getOrderRecommendationById = async orderRecommendationId => {
  const url = `${baseRoute}/${orderRecommendationId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getOrderRecommendations = async orderLineId => {
  const query = queryString.stringify({ orderLineId });
  const url = `${baseRoute}?${query}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const removeOrderRecommendationById = async orderRecommendationId => {
  const url = `${baseRoute}/${orderRecommendationId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
    // body: JSON.stringify(orderRecommendation),
  });

  if (response.ok) {
    return true;
  }
  return Promise.reject('Recommendation removal failed');
};
